module.exports = __webpack_public_path__ + "static/media/allClear_pay.e5258bb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/allClear_pay.jpg
// module id = 1893
// module chunks = 0 1